(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfDataViewHeight', [
    '$window', '$rootScope', function($window, $rootScope) {
      return {
        link: function(scope, ele, attrs) {
          var calculatePixels, handleTableHeight;
          calculatePixels = function() {
            var available_height, child, children_height, container_height, i, len, padding, ref, ref1, ref2;
            if (!(ele[0].children && (((ref = scope.formsData) != null ? ref.length : void 0) || ((ref1 = scope.formsData) != null ? ref1.length : void 0)))) {
              $rootScope.$broadcast('data-view:resized');
              return;
            }
            padding = 37;
            container_height = ele[0].clientHeight - padding;
            if (container_height <= 0) {
              $rootScope.$broadcast('data-view:resized');
              return;
            }
            children_height = 0;
            ref2 = ele[0].children;
            for (i = 0, len = ref2.length; i < len; i++) {
              child = ref2[i];
              child = $(child);
              if (!child.hasClass('forms-table-container') && !child.hasClass('maps-table-container')) {
                children_height += child[0].clientHeight;
              }
            }
            available_height = container_height - children_height;
            return handleTableHeight(available_height);
          };
          handleTableHeight = function(available) {
            var elem, form, form_height, half, i, len, map, map_height, ref, ref1;
            form = 49 + scope.formsData.length * 29;
            map = 49;
            ref = scope.mapsData;
            for (i = 0, len = ref.length; i < len; i++) {
              elem = ref[i];
              if (((ref1 = elem.layer_title) != null ? ref1.length : void 0) > 16) {
                map += 54;
              } else {
                map += 27;
              }
            }
            if (!scope.mapsData.length) {
              map += 27;
            }
            half = available / 2;
            if (map >= half && form >= half) {
              form_height = Math.max(half, 78);
              map_height = Math.max(half, 76);
            } else {
              form_height = form > half ? available - map : form;
              map_height = map > half ? available - form : map;
            }
            scope.form_table_style = {
              height: form_height
            };
            scope.map_table_style = {
              height: map_height
            };
            return $rootScope.$broadcast('data-view:resized');
          };
          calculatePixels();
          return scope.$on('resizable:resized', function() {
            return calculatePixels();
          });
        }
      };
    }
  ]);

}).call(this);
